import React from 'react';
import LegalLayout from '../LegalPage/LegalLayout';

const privacySections = [
    {
        heading: '1. Information We Collect',
        paragraphs: [
            'We gather information when you request an appointment, complete intake forms, engage with our team, or browse this website.',
        ],
        list: [
            'Identity and contact details such as your name, email address, phone number, and mailing address.',
            'Medical history, treatment preferences, imaging, and other clinical documentation shared as part of your care.',
            'Insurance and payment information collected through secure billing partners.',
            'Digital interactions including appointment requests, newsletter sign ups, and limited analytics that help us improve the site experience.',
        ],
    },
    {
        heading: '2. How We Use Your Information',
        paragraphs: [
            'Your information allows us to deliver thoughtful, individualized care and to support the operational needs of the clinic.',
        ],
        list: [
            'Verify your identity, respond to inquiries, and schedule consultations.',
            'Tailor treatment plans, communicate results, and coordinate with other providers at your request.',
            'Process payments, manage insurance claims, and maintain accurate records.',
            'Send service updates or educational resources that align with your preferences (you may opt out at any time).',
        ],
    },
    {
        heading: '3. How We Share Information',
        paragraphs: [
            'We only share your information with trusted parties that support your care or our operations, and we require them to protect your data.',
        ],
        list: [
            'Members of your care team and referral partners involved in treatment coordination.',
            'Accredited laboratories, surgical centers, pharmacies, or imaging facilities you choose to work with.',
            'Technology vendors that provide secure hosting, email, analytics, or payment processing services.',
            'Regulators or law enforcement when disclosure is required by applicable law or to safeguard vital interests.',
        ],
        note: 'We do not sell or rent your personal information.',
    },
    {
        heading: '4. Data Security and Retention',
        paragraphs: [
            'We follow industry best practices and HIPAA-aligned safeguards to protect your information, including encrypted systems, role-based access, and staff training.',
            'Records are retained only as long as necessary to fulfill the purposes described in this policy or as required by medical, legal, and regulatory obligations.',
        ],
    },
    {
        heading: '5. Your Choices and Rights',
        paragraphs: [
            'You are welcome to review, update, or request a copy of your records. Our team will guide you through any required forms and timelines.',
        ],
        list: [
            'Update your contact or insurance details at any visit or by calling the clinic.',
            'Request restrictions on how we communicate with you or share information.',
            'Opt out of non-essential communications by using the unsubscribe link or letting us know directly.',
            'File a complaint with the practice or the U.S. Department of Health and Human Services if you believe your privacy rights have been violated.',
        ],
    },
    {
        heading: "6. Children's Privacy",
        paragraphs: [
            'The clinic primarily serves adults. For patients under 18, a parent or legal guardian must provide consent and oversee the sharing of information.',
        ],
    },
    {
        heading: '7. Updates to This Policy',
        paragraphs: [
            'We may revise this Privacy Policy to reflect changes in regulations, technology, or clinic operations. When updates are published, the date below will be revised. Significant changes will be communicated through the channels we have on file.',
        ],
    },
];

const privacyCta = {
    title: 'Questions about your privacy?',
    description:
        'Our team is happy to explain how your information is used or to help you submit a records request.',
    primary: { label: 'Contact the Clinic', to: '/contact' },
    secondary: { label: 'Return Home', to: '/' },
};

const PrivacyPage = () => (
    <LegalLayout
        title="Privacy Policy"
        intro="Dr. Eugene Pereira, MD respects your privacy and is committed to protecting the personal information you share with our clinic online, by phone, or in person."
        sections={privacySections}
        lastReviewed="Nov 3, 2025"
        cta={privacyCta}
    />
);

export default PrivacyPage;
